import { useFormik } from 'formik';
import React from 'react';
import * as Yup from 'yup';

const initialValues = {
    firstName: '',
    lastName: '',
    email: '',
    mobile: '',
    preferredTime: '',
    preferredDay: '',
    consultant: 'Any Available Consultant',
    details: '',
    optIn: false
};

const validationSchema = Yup.object().shape({
    firstName: Yup.string().required('Required').max(40, 'Too long'),
    lastName: Yup.string().required('Required').max(40, 'Too long'),
    email: Yup.string().required('Required').email('Invalid Email'),
    mobile: Yup.string().optional().matches(/^[0-9]{10}$/, 'Invalid mobile number. It should be 10 digits long.'),
    preferredDay: Yup.string().required('Required'),
    preferredTime: Yup.string().required('Required'),
    details: Yup.string().max(600, 'Details too long'),
});

const consultants = [
    'Any Available Consultant',
    'Brandon Rowley',
    'Steven Wong',
    'John Garvey',
    'Angie Plantinga',
    'Pamela Martin',
    'Lysaundra Sparrowhawk',
    'Sandra Dowling',
    'Riley Shaw',
    'Anthony (Tony) Schwarz'];

const VipEventForm = ({ onSubmit, disabled, errorMsg, days }) => {
    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit: (formData) => onSubmit({ ...formData })
    });

    const getErrorMsg = (name) => {
        return formik.touched[name] && formik.errors[name] ? (
            <div style={{ color: 'red' }}>{formik.errors[name]}</div>
        ) : null;
    };

    const getFormGroupClass = (fieldName, override) => {
        const defaultClassName = override || 'form-group';
        return formik.touched[fieldName] && formik.errors[fieldName] ? `${defaultClassName} invalid` : `${defaultClassName}`;
    };

    return (
        <div className='container service-form my-4'>
            <h3>Register for the VIP Event</h3>
            {errorMsg ? <p className='alert alert-danger'>{errorMsg}</p> : null}
            <form onSubmit={formik.handleSubmit}>
                <div className="form-row">
                    <div className={getFormGroupClass('firstName') + " col-12 col-md-6"}>
                        <label htmlFor="firstName">First Name</label>
                        <input
                            className="form-control"
                            id="firstName"
                            name="firstName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.firstName}
                        />
                        {getErrorMsg('firstName')}
                    </div>

                    <div className={getFormGroupClass('lastName') + " col-12 col-md-6"}>
                        <label htmlFor="lastName">Last Name</label>
                        <input
                            className="form-control"
                            id="lastName"
                            name="lastName"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.lastName}
                        />
                        {getErrorMsg('lastName')}
                    </div>

                    <div className={getFormGroupClass('email') + " col-12"}>
                        <label htmlFor="email">Email</label>
                        <input
                            className="form-control"
                            id="email"
                            name="email"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.email}
                        />
                        {getErrorMsg('email')}
                    </div>

                    <div className={getFormGroupClass('mobile') + " col-12"}>
                        <label htmlFor="mobile">Mobile</label>
                        <input
                            className="form-control"
                            id="mobile"
                            name="mobile"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.mobile}
                        />
                        {getErrorMsg('mobile')}
                    </div>

                    <div className={getFormGroupClass('preferredDay') + " col-12"}>
                        <label htmlFor="preferredLocation">Preferred Day</label>
                        <select
                            className="form-control"
                            id="preferredDay"
                            name="preferredDay"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.preferredDay}
                        >
                            <option></option>
                            {days.map((day, index) => (
                                <option key={day} value={day}>
                                    {day}
                                </option>
                            ))}
                        </select>
                        {getErrorMsg('preferredDay')}
                    </div>

                    <div className={getFormGroupClass('preferredTime', '') + " col-12"}>
                        <label htmlFor="preferredTime">Preferred Time</label>
                        <select
                            className="form-control"
                            id="preferredTime"
                            name="preferredTime"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.preferredTime}
                        >
                            <option></option>
                            {['Morning', 'Mid-afternoon', 'Late afternoon'].map((time, index) => (
                                <option key={time} value={time} selected={index === 0}>
                                    {time}
                                </option>
                            ))}
                        </select>
                        {getErrorMsg('preferredTime')}
                    </div>

                    <div className={getFormGroupClass('consultant', '') + " col-12"}>
                        <label htmlFor="consultant">Have you worked with one of our Sales Consultants before?</label>
                        <select
                            className="form-control"
                            id="consultant"
                            name="consultant"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.consultant}
                        >
                            {consultants.map((consultant, index) => (
                                <option key={consultant} value={consultant} selected={index === 0}>
                                    {consultant}
                                </option>
                            ))}
                        </select>
                        {getErrorMsg('consultant')}
                    </div>

                    <div className={getFormGroupClass('details') + " col-12"}>
                        <label htmlFor="details">Tell us what you’re looking for</label>
                        <textarea
                            className="form-control"
                            id="details"
                            name="details"
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            value={formik.values.details}
                        />
                        {getErrorMsg('details')}
                    </div>

                    <div className='form-group'>
                        <div className='form-check'>

                            <input
                                type='checkbox'
                                className="form-check-input "
                                id="optIn"
                                name="optIn"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value='optIn'
                            />
                            <label class="form-check-label" for="optIn">
                                Yes, I consent to receive promotional emails from Fraserway RV. I understand that I can unsubscribe at any time.
                            </label>
                            {getErrorMsg('optIn')}
                        </div>
                    </div>
                </div>

                <button type="submit" disabled={disabled} className='btn btn-primary'>Submit</button>
            </form>
        </div>
    );
};

export default VipEventForm;
